import type { Nav, NavItem } from "$lib/gql/genCms/codegen";
import { page as pageStore } from "$app/stores";

import { writable, get } from "svelte/store";

export function scopeStore() {
  type Store = {
    active: NavItem[];
  };
  const initialscope: Store = { active: [] };

  const scope = writable<Store>(initialscope);

  const navTree = (
    nav: NavItem[],
    tree: any = {
      href: "",
      id: "",
      parentId: "",
      path: [],
      children: {},
      navItem: {},
    },
    parent: NavItem | null = null,
  ): any => {
    nav.forEach(item => {
      if (item.items && item.items.length > 0) {
        tree.children[item.id] = navTree(
          item.items,
          {
            href: item.href,
            id: item.id,
            parentId: parent ? parent.id : null,
            path: [...tree.path, item.id],
            children: {},
            navItem: item,
          },
          item,
        );
      } else {
        tree.children[item.id] = {
          href: item.href,
          id: item.id,
          parentId: parent ? parent.id : null,
          path: [...tree.path, item.id],
          navItem: item,
        };
      }
    });
    return tree;
  };

  const updateScope = (nav: Nav) => {
    const tree = navTree(nav.items);
    const { landing, collection } = get(pageStore).params;
    let landingNode = null;

    if (landing) {
      for (const key in tree.children) {
        if (tree.children[key].href === landing) {
          landingNode = tree.children[key];
          break;
        }
      }
    }

    if (landingNode) {
      scope.update(items => ({
        ...items,
        active: [landingNode.navItem],
      }));
    }

    if (collection && landingNode) {
      const findCollection = (node: any, collection: string): any => {
        if (node.href === collection) {
          return node;
        }
        for (const childKey in node.children) {
          const found = findCollection(node.children[childKey], collection);
          if (found) {
            return found;
          }
        }
        return null;
      };
      const collectionNode = findCollection(landingNode, collection);

      const pathItems: NavItem[] = [];
      const paths = [...(collectionNode?.path || [])];
      let currentNode = landingNode;
      for (let i = 0; i < paths.length; i++) {
        if (i === 0) {
          pathItems.push(currentNode.navItem);
        }

        if (currentNode.children && currentNode.children[paths[i + 1]]) {
          currentNode = currentNode.children[paths[i + 1]];
          pathItems.push(currentNode.navItem);
        } else {
          break;
        }
      }

      scope.update(items => ({
        ...items,
        active: pathItems,
      }));
    } else {
      scope.update(items => ({
        ...items,
        active: [],
      }));
    }
  };

  const highlight = (id: string, viewAll: boolean = false) => {
    if (viewAll) {
      //get current path
      const page = get(pageStore);
      const { landing, collection } = page.params;
      const splitId = id.split("/").filter(part => part && part !== ".");
      const idLanding = splitId[0];
      const idCollection = splitId[1];

      if (!collection && !idCollection) {
        if (landing === idLanding) {
          return true;
        }
      }

      if (collection && idCollection) {
        if (landing === idLanding && collection === idCollection) {
          return true;
        }
      }
    }
    return get(scope).active.some(item => item.id === id);
  };

  return {
    subscribe: scope.subscribe,
    set: scope.set,
    highlight,
    updateScope,
  };
}
export const scope = scopeStore();
